var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ReactiveModal",
    {
      staticClass: "modal_plan-task plan-task",
      class: { "iframe-view": _vm.iframeView },
      attrs: {
        id: "task-add-modal",
        "modal-size": "custom",
        title: "Добавление проектной задачи",
      },
      on: {
        close: function ($event) {
          return _vm.close()
        },
      },
      scopedSlots: _vm._u(
        [
          _vm.hideHeaderBtn
            ? {
                key: "left-actions",
                fn: function () {
                  return [_c("div")]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "task task_new" }, [
        _c("div", { staticClass: "task-summary" }, [
          _c(
            "div",
            { staticClass: "task-summary__project" },
            [
              _c("label", { attrs: { for: "userProjects" } }, [
                _vm._v("Проект:"),
              ]),
              _vm._v(" "),
              _c("SelectSearch", {
                staticClass: "task-summary__project-select",
                attrs: {
                  id: "userProjects",
                  name: "userProjects",
                  placeholder: "Выберите проект",
                  items: _vm.userProjects,
                  active: _vm.projectId,
                  searchText: _vm.projectText,
                },
                on: {
                  changeSearchText: (val) => (_vm.projectText = val.trim()),
                  selectChange: _vm.setProject,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "task-summary__url" }, [
            _c("label", { attrs: { for: "projectUrl" } }, [_vm._v("URL:")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.urlText,
                  expression: "urlText",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "form-input",
              attrs: {
                id: "projectUrl",
                type: "text",
                placeholder: "Введите url",
                disabled: !_vm.projectId,
              },
              domProps: { value: _vm.urlText },
              on: {
                blur: [
                  function ($event) {
                    return _vm.checkUrl()
                  },
                  function ($event) {
                    return _vm.$forceUpdate()
                  },
                ],
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.urlText = $event.target.value.trim()
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _vm.errorText
          ? _c("p", { staticClass: "error-txt" }, [
              _vm._v(_vm._s(_vm.errorText)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showNewTaskForm
          ? _c(
              "div",
              [
                _c("FormNewTask", {
                  attrs: {
                    urlId: _vm.urlId,
                    service: _vm.service,
                    "hide-header-btn": _vm.hideHeaderBtn,
                    "allow-no-runs": true,
                  },
                  on: { planTaskCreated: (v) => _vm.addTask(v) },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showAddTaskForm
          ? _c(
              "div",
              [
                _c("FormAddTask", {
                  on: { planTaskCreated: (v) => _vm.addTask(v) },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }